import { Button } from '@/components/ui/button';
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@/components/ui/modal';

interface InstitutionalAccessExpiredModalProps {
  open: boolean;
  schoolName: string;
  endedDate?: string | null;
  onClose: () => void;
}

const InstitutionalAccessExpiredModal = ({
  open,
  schoolName,
  endedDate,
  onClose,
}: InstitutionalAccessExpiredModalProps) => (
  <Modal
    open={open}
    onClose={onClose}
    name="institutional-access-expired"
    title="Institution Access Ended"
    description="Your institution-purchased Ora access has ended."
  >
    <ModalHeader>
      <h2>Institution Access Ended</h2>
    </ModalHeader>
    <ModalBody>
      <p className="!my-0">
        Your access through {schoolName} ended
        {endedDate ? ` on ${endedDate}` : ''}.
      </p>
    </ModalBody>
    <ModalFooter>
      <Button onClick={onClose} context="modal" variant="outline">
        Got It
      </Button>
    </ModalFooter>
  </Modal>
);

export default InstitutionalAccessExpiredModal;
